import api from '@/api'

const { $commission, $core , $pricing, $student} = api;

export const { $payings } = $commission;
export const { $settings, $applications } = $core;
export const {$settingsPricing} = $pricing;
export const { $settingsStudents } = $student;

